import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SubController = _resolveComponent("SubController");
    const _component_List = _resolveComponent("List");
    const _component_StoreBulkEditDialog = _resolveComponent("StoreBulkEditDialog");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SubController),
        _createCommentVNode(" 상점 리스트 "),
        _createVNode(_component_List),
        _createCommentVNode(" 일괄설정 dialog "),
        _createVNode(_component_StoreBulkEditDialog)
    ]));
}
